export const parseUndefString = (v) => v === 'undefined' ? undefined : v;